import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress, Typography, useMediaQuery } from '@mui/material';

import { useGetMoviesQuery } from '../../services/tmdb';
import { FeaturedMovie, MovieList, Pagination } from '../index';

function Movies() {
  const [page, setPage] = useState(1);
  const { genreIdOrCategoryName, searchQuery } = useSelector((state) => state.currentGenreOrCategory);

  // Destructuring the response from the useGetMoviesQuery hook
  const { data, error, isFetching } = useGetMoviesQuery({ genreIdOrCategoryName, page, searchQuery });

  const lg = useMediaQuery((theme) => theme.breakpoints.only('lg')); // Detect large screens
  const numberOfMovies = lg ? 17 : 19; // If large screen, show 19 movies; otherwise, show 17

  // Show a loading spinner while the movies data is still being fetched
  if (isFetching) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress size="4rem" />
      </Box>
    );
  }

  // If no movies are found, show a message to the user
  if (!data.results.length) {
    return (
      <Box display="flex" alignItems="center" mt="20px">
        <Typography variant="h4">
          No movies found that much that name.
          <br />
          Please search for something else.
        </Typography>
      </Box>
    );
  }

  // If there is an error fetching the data, display a simple error message
  if (error) {
    return 'An error has occurred';
  }

  // If data is successfully fetched and contains movies render the MovieList component and Pagination component
  return (
    <div>
      <FeaturedMovie movie={data?.results[0]} />
      <MovieList movies={data} numberOfMovies={numberOfMovies} excludeFirst />
      <Pagination currentPage={page} setPage={setPage} totalPages={data.total_pages} />
    </div>
  );
}

export default Movies;
